var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPwa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pwa-stop",
    transform: "translate(-3829 -6459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ionic-stop",
    transform: "translate(3829.002 6458.833)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#478aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#478aff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "website",
    transform: "translate(3845.029 6475.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M82.67,198.91a1.586,1.586,0,0,1-.4.963,1.536,1.536,0,0,1-.972.4H69.177a1.37,1.37,0,0,1-1.377-1.359V189.7H82.67v5.813A16.758,16.758,0,0,1,82.67,198.91Z",
    transform: "translate(-64.533 -180.817)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M50.714,53H35.353A2.34,2.34,0,0,0,33,55.322v12.85a3.121,3.121,0,0,0,3.136,3.1H49.931a3.121,3.121,0,0,0,3.136-3.1.783.783,0,0,0-1.566,0,1.557,1.557,0,0,1-1.566,1.548h-13.8a1.557,1.557,0,0,1-1.566-1.548V57.684H51.5V64.3a.783.783,0,0,0,1.566,0V55.322A2.34,2.34,0,0,0,50.714,53Zm-3.172,1.548a.774.774,0,1,1-.783.774A.779.779,0,0,1,47.542,54.548Zm3.919.774a.783.783,0,1,1-.783-.774A.779.779,0,0,1,51.461,55.322Zm-16.895,0a.779.779,0,0,1,.783-.774h9.97a2.3,2.3,0,0,0,.014,1.588H34.566Z",
    transform: "translate(-31.299 -50.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M2.678-6.3H.5v4.6H2.027V-2.8h.651A1.708,1.708,0,0,0,4.467-4.557,1.7,1.7,0,0,0,2.678-6.3Zm-.3,2.236H2.027v-.973h.355a.464.464,0,0,1,.493.487A.464.464,0,0,1,2.382-4.064ZM9.748-6.3,9.161-4.032,8.176-6.3H7.624L6.642-4.04l-.6-2.26H4.388L5.822-1.7H7.15L7.9-3.612,8.65-1.7H9.978l1.427-4.6Zm4.676,4.6h1.7L14.279-6.3H12.74L10.905-1.7h1.651l.206-.638h1.465Zm-.479-1.71h-.9l.447-1.268Z",
    transform: "translate(4.467 18.85)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwa);
export default __webpack_public_path__ + "static/media/pwa.44c3aebdc2863b4703549264183d9030.svg";
export { ForwardRef as ReactComponent };